import { useRouter } from 'next/router'

import { BlockContent } from '~/components/BlockContent'
import ROUTES from '~/shared/constants/routes.const'
import { studytipsItem } from '~/shared/types/studyTips.types'

import styles from '~/shared/styles/SanityBlock.module.css'
import { BackButton } from '~/components/Buttons/BackButton'

import TipsNavigation from '~/study-tips/components/TipsNavigation'

interface StudyTipsContentPageProp {
  contentDetails: studytipsItem
  contentKey: number
  itemKey: string
}

const StudyTipsContentPage = ({ contentDetails, itemKey }: StudyTipsContentPageProp): React.ReactElement => {
  const router = useRouter()
  const { item, maxId, name } = contentDetails || { item: { name: '', id: 1, description: [] }, maxId: 1 }

  if (!item?.name) {
    router.push(ROUTES.NOT_FOUND)
  }

  const style = {
    backgroundSize: '42.5%',
  }

  return (
    <section className="min-h-screen py-8 px-4 lg:px-8 sm:px-16" style={style}>
      <BackButton href={`${ROUTES.STUDY_TIPS}/${itemKey}`} pageTitle={name} />
      <div className="max-w-3xl w-full mx-auto">
        <div className="gradient-border-container rounded">
          <div className="bg-white rounded min-h-sm py-8 px-4 md:px-8 lg:px-20">
            <h1 className="text-center text-h3 font-bold tracking-wider my-3">{item?.name}</h1>
            <div className="relative">
              <BlockContent blocks={item?.description || []} className={`${styles['sanity-block']}`} />
            </div>
          </div>
        </div>

        <TipsNavigation activePageId={item?.id} path={`${ROUTES.STUDY_TIPS}/${itemKey}/`} totalPages={maxId} />
      </div>
    </section>
  )
}

export default StudyTipsContentPage
